import i18n from 'i18next';
import * as Yup from 'yup';

import { variableValidateSchema } from './variableValidateSchema';

export const wafWhiteListFormSchema = ({ optionList, skipRuleOption }) => {
  return Yup.object().shape({
    name: Yup.string().required(() => i18n.t('validation:waf.wafWhiteListNameRequired')),
    conditions: Yup.array().of(
      Yup.object().shape({
        field: Yup.string(),
        argument: Yup.string().nullable(),
        operator: Yup.string(),
        values: Yup.array().of(
          Yup.object().shape({
            value: Yup.string().test({
              name: 'conditions-value-validation',
              test: async function (value) {
                if (!value || value.trim() === '') {
                  return this.createError({ message: i18n.t('validation:valueRequired') });
                }
                const indexString = this.path.split('.')[0];
                const index = parseInt(RegExp(/\d+/).exec(indexString)?.[0] ?? '');
                const { field, operator } = this?.options?.context?.conditions[index] ?? {};

                if (field && operator) {
                  const variableSchema = variableValidateSchema(field, operator, optionList);

                  try {
                    await variableSchema.validate(value, { context: this.options.context });
                    return true;
                  } catch (error: any) {
                    return this.createError({ message: error.message });
                  }
                } else {
                  return true;
                }
              },
            }),
          }),
        ),
      }),
    ),
    rulesets: Yup.array()
      .of(
        Yup.string().oneOf(
          skipRuleOption.map((option) => option.value),
          i18n.t('validation:waf.invalidSelection'),
        ),
      )
      .min(1, i18n.t('validation:waf.mustSelectAtLeastOneRule'))
      .required(i18n.t('validation:required')),
  });
};
